import React from 'react';

export var SpeakerIcon = function SpeakerIcon(props) {
  return React.createElement(
    "svg",
    {
      "data-qa": "SpeakerIcon",
      width: "100%",
      height: "100%",
      viewBox: "0 0 50 50",
      preserveAspectRatio: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    React.createElement("path", {
      fill: props.circleFill,
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25z"
    }),
    React.createElement("path", {
      fill: props.iconFill,
      d: "M10.938 21.875v6.25c0 .859.703 1.562 1.562 1.562h4.688l5.14 5.14c.985.985 2.672.282 2.672-1.109V16.265c0-1.39-1.688-2.094-2.672-1.11l-5.14 5.157H12.5c-.86 0-1.563.703-1.563 1.563zM32.03 25c0-2.766-1.593-5.141-3.906-6.297V31.28A6.99 6.99 0 0032.031 25zm-3.906-11.797v.312c0 .594.39 1.11.938 1.328A10.943 10.943 0 0135.938 25c0 4.593-2.844 8.547-6.876 10.156-.562.219-.937.734-.937 1.328v.313c0 .984.984 1.671 1.89 1.328C35.313 36.109 39.063 31 39.063 25s-3.75-11.11-9.046-13.125c-.907-.36-1.891.343-1.891 1.328z"
    })
  );
};